document.addEventListener("DOMContentLoaded", function () {
  function waitForElement(selector, callback) {
    var interval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10000;
    var startTime = Date.now();
    var intervalId = setInterval(function () {
      var element = document.querySelector(selector);
      if (element) {
        clearInterval(intervalId);
        callback(element);
      } else if (Date.now() - startTime > timeout) {
        clearInterval(intervalId);
        console.warn("Element with selector \"".concat(selector, "\" not found within timeout."));
      }
    }, interval);
  }
  waitForElement('.mas-backstock-cstm-preorder-btn', function (button) {
    var originalText = button.textContent;
    button.addEventListener('click', function (event) {
      setTimeout(function () {
        button.textContent = originalText;
      }, 0);
    });
  });
  waitForElement('.mas-backstock-cstm-preorder-label', function (label) {
    var labelContainer = document.querySelector(".mini-cart-preorder-label");
    if (labelContainer) {
      labelContainer.innerHTML = label.innerHTML;
    }
  });
});